<template>
  <v-dialog v-model="dialog" max-width="400">
    <div class="asta-order">
      <v-card>
        <v-card-title class="navy headline">
          <v-icon left class="white--text">settings_backup_restore</v-icon>
          <span class="white--text">Ordine partecipanti</span>
          <v-spacer></v-spacer>
          <v-btn depressed class="white--text" light icon @click="dismiss">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-list
          dense
          class="overflow-y-auto mr-1 pr-1"
          max-height="450px"
          :class="{ 'nice-scroll': !is_mobile }"
          v-if="asta_squadre && _.size(asta_squadre) > 0"
        >
          <draggable
            v-model="asta_squadre_drag"
            :disabled="!this.admin || this.isAstaInCorso"
            ghost-class="ghost"
            animation="150"
            group="asta-order"
            delay="80"
            delayOnTouchOnly="true"
          >
            <transition-group class="lista-squadre">
              <v-list-item
                v-for="sq in asta_squadre_array"
                :key="sq.id"
                class="item"
              >
                <v-list-item-avatar>
                  <img :src="squadra(sq.id).pic" />
                </v-list-item-avatar>

                <v-list-item-content>
                  {{ sq.name }}
                </v-list-item-content>

                <v-icon class="navy--text" left>drag_indicator</v-icon>
              </v-list-item>
            </transition-group>
          </draggable>
        </v-list>
        <div class="lista-vuota py-4" v-else>Nessuna squadra.</div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import draggable from "vuedraggable";

export default {
  name: "asta-order",
  mixins: [mixins],
  components: { draggable },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {
    console.log("--> AstaOrder ready.");
    db.on("showAstaOrder", this.show);
  },
  destroyed() {
    console.log("<-- AstaOrder destroyed.");
    db.off("showAstaOrder", this.show);
  },
  methods: {
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
  },
  computed: {
    asta_squadre_drag: {
      get() {
        return this.asta_squadre_array;
      },
      set(value) {
        for (var i = 0; i < value.length; i++) {
          let squadra = value[i];
          if (squadra.order != i + 1) {
            db.setOrdineSquadra(squadra.id, i + 1);
          }
        }
      },
    },
    ...Vuex.mapGetters(["asta_squadre_array", "is_mobile"]),
  },
};
</script>
<style lang="scss" scoped>
.lista-vuota {
  width: 100%;
  text-align: center;
}
.ghost {
  opacity: 0.5;
}
.item {
  cursor: pointer;
}
</style>
